import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { conditions } from "@/data/conditions";
import { CONDITION_IMAGES } from "@/data/conditionImages";

const FEATURED_SLUGS = [
  "travelers-diarrhea",
  "dengue-and-tropical-fevers",
  "sunburn-heat-illness",
  "respiratory-infections",
  "urinary-tract-infections",
  "food-poisoning-stomach-pain",
];

const ConditionsShowcase = () => {
  const featured = FEATURED_SLUGS.map((slug) =>
    conditions.find((c) => c.slug === slug)
  ).filter(Boolean) as typeof conditions;

  return (
    <section id="conditions" className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Common Conditions We Treat
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto">
            Feeling unwell while travelling in Brazil? These are the health problems
            tourists and expats ask us about most.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {featured.map((condition) => {
            const image = CONDITION_IMAGES[condition.slug];
            return (
              <Link
                key={condition.slug}
                to={`/what-we-treat/${condition.slug}`}
                className="group block rounded-xl overflow-hidden border border-border bg-card shadow-sm hover:shadow-lg transition-all duration-300"
              >
                {image && (
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    width={1200}
                    height={800}
                    className="w-full aspect-[3/2] object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                )}
                <div className="p-5">
                  <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                    {condition.name}
                  </h3>
                  <p className="text-sm text-text-secondary line-clamp-3">
                    {condition.summary}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/what-we-treat"
            className="inline-flex items-center text-primary font-medium hover:underline"
          >
            See all conditions we treat
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ConditionsShowcase;
